import {StreamInfo} from "@/models/groups/streamInfo.model";
import {GroupDeviceInfo} from "@/models/groups/groupDeviceInfo.model";

export class Group {
  public id: string;
  public clientId: string;
  public parentId: string;
  public name: string;
  public streamInfo: StreamInfo[];
  public devices: string[];
  public deviceInfo: GroupDeviceInfo[];
  public created: Date;

  constructor(obj: any) {
    this.id = obj?.id;
    this.clientId = obj?.clientId;
    this.parentId = obj?.parentId;
    this.name = obj?.name;
    this.streamInfo = obj?.streamInfo;
    this.devices = obj?.devices;
    this.deviceInfo = obj?.deviceInfo ?? [];
    this.created = obj?.created;
  }
}
